<div class="ots-page">
  <div class="ots-page-body d-flex flex-direction-column gap-32 p-x-24 p-t-24">
    <div class="d-flex gap-32 full-width">
      <span class="ots-skeleton flex-none" width="74px" height="36px"></span>
      <span class="ots-skeleton flex-none" width="141px" height="45px"></span>
    </div>

    <span class="ots-skeleton full-width" height="94px"></span>

    <div class="d-flex flex-direction-column gap-16 full-width">
      <span class="ots-skeleton full-width" height="91px"></span>
      <span class="ots-skeleton full-width" height="91px"></span>
    </div>
  </div>

  <div class="ots-page-footer p-x-24 p-t-16 p-b-16">
    <span class="ots-skeleton d-block full-width" height="44px"></span>
  </div>
</div>
